export const SITE = {
  company: "AtlasForge Financial",
  parentTagline:
    "Next-generation consumer finance platforms and API infrastructure.",
  email: "customersupport@atlasforgefinancial.com",
  phone: "843-291-2556",
  loginUrl: "#",
  // Legacy top-level fallback — retained so any older caller that reads
  // `SITE.appStoreUrl` / `SITE.playStoreUrl` without a product prop still
  // resolves to a valid link (Safe to Spend, our first shipped app).
  appStoreUrl: "https://apps.apple.com/us/app/safe-to-spend-365/id6792137232",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.atlasforge.safetospend",
  socials: {
    linkedin: "https://www.linkedin.com/company/atlasforgefinancial",
    instagram: "https://www.instagram.com/atlasforgefin/",
    facebook: "https://www.facebook.com/atlasforgefinancial",
    tiktok: "https://www.tiktok.com/@safe.to.spend.365",
  },
  products: {
    ember: {
      name: "Ember360",
      tagline: "Your money, your portfolio, all in one place.",
      accent: "#FF5A36",
      appStoreUrl: "https://apps.apple.com/us/app/ember360/id6796043696",
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.atlasforge.ember360",
    },
    safeToSpend: {
      name: "Safe to Spend 365",
      tagline: "Know what you can spend — with confidence.",
      accent: "#00C48C",
      appStoreUrl:
        "https://apps.apple.com/us/app/safe-to-spend-365/id6792137232",
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.atlasforge.safetospend",
    },
  },
};

/**
 * Normalise the free-form `product` prop that gets passed to `StoreBadges`
 * — anywhere in the codebase we use variants like "ember", "ember-hero",
 * "home-ember", "safe-to-spend", "home-safe-to-spend", "sts-hero",
 * "sts-features", etc. Anything mentioning Safe to Spend (`safe`, `sts`,
 * `s2s`) resolves to Safe to Spend; everything else falls back to Ember
 * (the default product prop).
 */
export function productKey(product = "ember") {
  return /safe|sts|s2s/i.test(product) ? "safeToSpend" : "ember";
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * External mobile-app backend that owns the corporate / employer flow
 * (packages, inquiry intake, Stripe invoicing, master-code generation,
 * redemption). This marketing site is a pure consumer of its public
 * endpoints — set the URL via `REACT_APP_MOBILE_APP_API` in `.env`.
 *
 * Falls back to `REACT_APP_BACKEND_URL` in local dev only so the pricing
 * calculator + inquiry form render something coherent before the real URL
 * is wired.
 */
export const MOBILE_APP_API =
  process.env.REACT_APP_MOBILE_APP_API || process.env.REACT_APP_BACKEND_URL;
